// @flow
import { createContext } from 'react';

export const FlinkPoolContext = createContext({});
